
import {myEmbryoList} from './js/gift';
import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data(){
return {
bannerimg:'',
myEmbryoList,
title:'',
bigtitle:'',
decstion:false,
inventory:0,
points:'',
address:'',
exchangeInstructions:'',
num:1,
confirmshow:false,

}
},
components: {
Confirm,XTextarea,XButton,XHeader,Divider, Cell, Group, Grid, GridItem, GroupTitle, InlineXNumber
},
directives: {
TransferDom
},
methods:{
getData(goodsid){
fetch('post',urlConfig.getShoppingCard +'?personInfoId='+this.paramsData.personInfoId+'&gzhArea='+this.paramsData.hosCode).then(response => {
for(let i=0;i<response.length;i++){
if(response[i].goodsId == goodsid){
this.goodsid = response[i].goodsId;
this.points = response[i].goodsPrice;
this.num = 1;
this.bannerimg = response[i].detailImage;
this.title = response[i].shopDisplayName;
this.bigtitle =  response[i].shopDisplayName.replace('<br/>','');
this.inventory = response[i].goodsNum;
this.exchangeInstructions = response[i].exchangeInstructions;
}
}

}).catch(error => {

});

},  //获取卡券类型
getInventoryData(id){
fetch('get',urlConfig.jifenInventory + '?goodsId=' + id).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false})
this.inventory = response.goodsNum;

}).catch(error => {

})
},//获取胚胎库存信息
giftClick(goodsid){
this.getData(goodsid);
document.body.scrollTop = 0
document.documentElement.scrollTop = 0
},//选择卡券类型
giveHide(){
this.address ='';
},
giveConfirm(){
this.address = this.address.trim();
if(this.address !=''){
this.exchangeAddress = new URLSearchParams();
this.exchangeAddress.append('personInfoId',this.paramsData.personInfoId);
this.exchangeAddress.append('address',this.address);
fetch('post',urlConfig.addMaiAddress,this.exchangeAddress).then(response => {
this.giveHide();
this.confirmshow=false;
this.submit();
}).catch(error => {
})
}else {
this.$vux.toast.text('请输入邮寄地址！');
}
},
submit(){
fetch('post',urlConfig.jifengetTel+'?personInfoId='+this.paramsData.personInfoId).then(response => {  //获取电话号码
this.tel = response;
this.exchangeParma = new URLSearchParams();
this.exchangeParma.append('personInfoId',this.paramsData.personInfoId);
this.exchangeParma.append('orderMoney',this.totalPoints);
this.exchangeParma.append('mobile',this.tel);
this.exchangeParma.append('goodsInfos',this.goodsid + ":" + this.num);
this.exchangeParma.append('gzhArea',this.paramsData.hosCode);
fetch('post',urlConfig.jifenPayIntegral,this.exchangeParma).then(response => {
if(this.paramsData.title.substr(0, 2) == '胚胎'){
this.$router.push({ path: 'integralMallOrder', query: {bigtitle:this.bigtitle,mobile:this.tel,chargeId:this.paramsData.chargeId, sysid:this.paramsData.sysid, dqrq:this.paramsData.dqrq, patientId:this.paramsData.patientId,months:this.paramsData.months,orderId: response.orderId,personInfoId:this.paramsData.personInfoId,title:this.title,num:this.num,total:this.totalPoints,integra:this.paramsData.Mypoints,xm:this.paramsData.xm,sfzh:this.paramsData.sfzh,openid:this.paramsData.openid,sign:this.$route.query.sign,hosCode:this.paramsData.hosCode}})

}else {
this.$router.push({ path: 'integralMallOrder', query: {bigtitle:this.bigtitle,mobile:this.tel,orderId: response.orderId,personInfoId:this.paramsData.personInfoId,title:this.title,num:this.num,total:this.totalPoints,integra:this.paramsData.Mypoints,xm:this.paramsData.xm,sfzh:this.paramsData.sfzh,openid:this.paramsData.openid,sign:this.$route.query.sign,hosCode:this.paramsData.hosCode}})

}
}).catch(error => {
})
}).catch(error => {
});
},
exchangeClick(){
if(this.inventory != 0){
this.totalPoints = this.points * this.num;
if(this.totalPoints <= this.paramsData.Mypoints){

if(this.title.indexOf('好孕果') != -1){
this.confirmshow =true;
}else{
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.submit();
}

}else {
promptMessage('提示',"您的积分不足，你目前的可用于兑换礼品卡的积分为"+this.paramsData.Mypoints);
this.$store.commit('updateLoadingStatus',{isLoading:false});
}
}else {
promptMessage('提示','该商品没有库存了，请选择其他商品！');
}

}  //立即兑换
},
mounted(){
this.paramsData = this.$route.query;
if(this.paramsData.title.substr(0, 2) !== '胚胎'){
this.getData(this.paramsData.goodsid);
this.decstion = true;
}else {

this.$store.commit('updateLoadingStatus',{isLoading:false});
this.title = this.paramsData.title;
this.decstion = false;
for(let j = 0;j<myEmbryoList.length;j++){
if(myEmbryoList[j].txt == this.title){
this.points = myEmbryoList[j].points;
this.goodsid = myEmbryoList[j].goodsid;
this.bannerimg = myEmbryoList[j].detailImg;
this.getInventoryData(this.goodsid);

}
}

}

}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallDetail.vue